import { Component } from '@angular/core';

import { ConfirmationService, PrimeTemplate } from 'primeng/api';

import { MessageService } from '../../../services/message.service';

import { Dialog } from '../../../models/dialog.model';
import { DialogEnum, OptionEnum } from '../../../enumerators/messages.enum';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {NgClass, NgFor} from '@angular/common';
import { Button } from 'primeng/button';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: true,
  imports: [ConfirmDialogModule, PrimeTemplate, NgFor, Button, NgClass]
})
export class DialogComponent {
  dialog: Dialog = new Dialog();

  public animation: string = "";
  public icon: string = "";
  public isOpen: boolean = false;
  public OptionEnum = OptionEnum;
  public iconClass: string = "";

  constructor(private dialogService: MessageService, private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.dialogService.startDialog().subscribe((dialogo: Dialog) => {
      this.dialog = dialogo;
      this.openDialog();
    });
  }

  openDialog()
  {
    this.setDialogData(this.dialog);

    this.confirmationService.confirm(
    {
      message: this.dialog.message,
      header: this.dialog.title,
      icon: this.icon,
      accept: () =>
      {
        this.closeDialog(true);
      },
      reject: () => {
        this.closeDialog(false);
      },
      key: 'dialog'
    });
  }

  closeDialog(response: any) {
    this.animation = "fadeOutDown";

    setTimeout(() => {
      this.dialogService.sendDialogResponse(response);
      this.icon = "";
      this.isOpen = false;
      this.dialog = new Dialog();
    }, 310);

  }

  setDialogData(dialog: Dialog) {
    switch (dialog.type) {
      case DialogEnum.Normal:
        this.icon = "";
        break;

      case DialogEnum.Information:
        this.icon = "icon icon-info";
        break;

      case DialogEnum.Advise:
        this.icon = "icon icon-warning";
        this.iconClass = "aviso";
        break;

      default:
        break;
    }
  }
}
